exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n¨ .menu-label[data-v-a500fd74]{border-top:1px solid #cdcdcd;border-bottom:1px solid #cdcdcd;padding:6px 0\n}\nul[data-v-a500fd74]{list-style:none;margin:0;padding:0\n}\nul li[data-v-a500fd74]{padding:7px 0;border-bottom:1px solid #cdcdcd\n}\nul li li[data-v-a500fd74]{padding-left:24px;border-bottom:none\n}\n.is-active[data-v-a500fd74]{font-weight:700;background-color:unset!important;color:unset!important\n}", ""]);

// exports
